export default "__VITE_ASSET__CDgJXlAb__"